<template>
  <v-app>
    <div>
      <v-row justify="center">
        <v-dialog v-model="dialog" width="400px">
          <v-card>
            <v-card-title class="text-h7 red lighten-1" style="color: white">
              Notification
            </v-card-title>
            <v-card-text class="setText">
              <p class="textUser">
                Yth. <b style="font-style: italic">{{ userName }}</b>
              </p>
              <p class="textParagraf">
                Password anda akan kadaluwarsa tanggal <b>{{ expiredDate }}</b
                >. Segera lakukan pergantian password Anda melalui menu change
                password atau klik tombol berikut.
              </p>
              <div class="buttonset">
                <v-btn
                  color="orange"
                  dark
                  small
                  style="color: white"
                  link
                  to="/password-change"
                  @click="dialog = false"
                >
                  Change Password
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'notif-user',
  props: {
    getNotif: {
      type: Boolean,
      default: false,
    },
    expiredDate: {
      type: String,
      default: null,
    },
    userName: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      dialog: false,
    };
  },

  mounted() {
    this.dialogCek();
  },

  methods: {
    dialogCek() {
      if (this.getNotif) {
        this.dialog = true;
      } else {
        this.dialog = false;
      }
    },
  },
};
</script>
<style scoped>
.setText {
  font-size: 13px;
  font-weight: 500;
  margin-top: 12px;
  font-family: Arial, sans-serif;
}
.buttonset {
  text-align: center;
}
.textUser {
  margin-bottom: -1px;
  font-size: 14px;
}
.textParagraf {
  text-align: justify;
}
</style>
